import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table, Button, Grid, IconButton } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import moment from "moment";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavLink } from "shards-react";
import { Delete } from "@material-ui/icons";
const useStyles = makeStyles({
  heading: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "14px",
    fontWeight: "600",
    color: "#3D5279"
  },
  text: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "14px"
  },
  type: {
    backgroundColor: "yellow",
    padding: "5px",
    fontSize: "10px"
  }
});

export default function TableView(props) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.heading}>Sl No.</TableCell>
            <TableCell className={classes.heading}>Company</TableCell>
            <TableCell className={classes.heading}>Full Name</TableCell>
            <TableCell className={classes.heading}>Designation</TableCell>
            <TableCell className={classes.heading}>Date</TableCell>

            <TableCell className={classes.heading} align="center">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        {props.data && props.data.meetingNotes && (
          <TableBody>
            {props.data.meetingNotes.map((article, index) => (
              <TableRow key={article.id}>
                <TableCell className={classes.text}>{index+1}</TableCell>
                <TableCell className={classes.text}>
                  {article.customer && article.customer.Company}
                </TableCell>
                <TableCell className={classes.text}>
                  {article.customer && article.customer.FullName}
                </TableCell>
                <TableCell className={classes.text}>
                  {article.customer && article.customer.Designation}
                </TableCell>
                <TableCell className={classes.text}>
                  {moment(article.updated_at).format("DD/MM/YYYY hh:mm a")}
                </TableCell>

                <TableCell className={classes.text} align="center">
                  {/* <Button>
                                            View
                                        </Button> */}
                  <NavLink
                    tag={RouteNavLink}
                    to={`/meetingNote/${article.id}`}
                    style={{ padding: "0px" }}
                  >
                    View
                  </NavLink>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}
